document.addEventListener('DOMContentLoaded', function () {
    // =======================
    // ARROW MENU
    // =======================
    var dropdownSelectors = '.navbar-nav .dropdown-toggle, .search-engine-wrapper .dropdown-toggle';

    document.querySelectorAll(dropdownSelectors).forEach(function (el) {
        // Aggiungi la freccia
        el.insertAdjacentHTML('beforeend', "<div class='arrow arrow--smallest arrow--down arrow--white ms-1'><span></span><span></span></div>");
        // Gestione click
        el.addEventListener('click', function (e) {
            // Toggle freccia attiva su questo
            var arrow = el.querySelector('.arrow');
            if (arrow) arrow.classList.toggle('active');
            // Rimuovi freccia attiva dagli altri
            document.querySelectorAll(dropdownSelectors).forEach(function (other) {
                if (other !== el) {
                    var otherArrow = other.querySelector('.arrow');
                    if (otherArrow) otherArrow.classList.remove('active');
                }
            });
        });
    });

    // Gestione click fuori dal menu per chiudere le frecce attive
    document.addEventListener('mouseup', function (e) {
        var mainmenus = document.querySelectorAll('.dropdown');
        var isInside = false;
        mainmenus.forEach(function (menu) {
            if (menu === e.target || menu.contains(e.target)) {
                isInside = true;
            }
        });
        if (!isInside) {
            document.querySelectorAll('.dropdown-toggle .arrow').forEach(function (arrow) {
                arrow.classList.remove('active');
            });
        }
    });
});